import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class CustomPropertyAttributeValueModel extends Model {
  @attr('string') value!: string;

  @belongsTo('property', {
    inverse: null,
    async: false,
  })
  property!: ModelRegistry['property'];

  @belongsTo('multi-unit', {
    inverse: null,
    async: false,
  })
  multiUnit!: ModelRegistry['multi-unit'];

  @belongsTo('custom-property-attribute', {
    inverse: 'customPropertyAttributeValues',
    async: false,
  })
  customPropertyAttribute!: ModelRegistry['custom-property-attribute'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'custom-property-attribute-value': CustomPropertyAttributeValueModel;
  }
}
